/** Action ID constants — mirrors AuthZConstants.java in iam-gateway. */
export const PERMISSIONS = {
  // Organization
  ACTION_ORG_VIEW: '10000000-0000-0000-0000-000000000001',
  ACTION_ORG_CREATE: '10000000-0000-0000-0000-000000000002',
  ACTION_ORG_UPDATE: '10000000-0000-0000-0000-000000000003',
  ACTION_ORG_DELETE: '10000000-0000-0000-0000-000000000004',
  ACTION_ORG_INVITE: '10000000-0000-0000-0000-000000000005',
  ACTION_ORG_MANAGE_MEMBERS: '10000000-0000-0000-0000-000000000006',

  // Role
  ACTION_ROLE_VIEW: '20000000-0000-0000-0000-000000000001',
  ACTION_ROLE_CREATE: '20000000-0000-0000-0000-000000000002',
  ACTION_ROLE_UPDATE: '20000000-0000-0000-0000-000000000003',
  ACTION_ROLE_DELETE: '20000000-0000-0000-0000-000000000004',

  // Group
  ACTION_GROUP_VIEW: '30000000-0000-0000-0000-000000000001',
  ACTION_GROUP_CREATE: '30000000-0000-0000-0000-000000000002',
  ACTION_GROUP_UPDATE: '30000000-0000-0000-0000-000000000003',
  ACTION_GROUP_DELETE: '30000000-0000-0000-0000-000000000004',
  ACTION_GROUP_MANAGE_MEMBERS: '30000000-0000-0000-0000-000000000005',

  // User
  ACTION_USER_VIEW: '40000000-0000-0000-0000-000000000001',
  ACTION_USER_CREATE: '40000000-0000-0000-0000-000000000002',
  ACTION_USER_UPDATE: '40000000-0000-0000-0000-000000000003',
  ACTION_USER_DELETE: '40000000-0000-0000-0000-000000000004',

  // Resource
  ACTION_RESOURCE_VIEW: '50000000-0000-0000-0000-000000000001',
  ACTION_RESOURCE_CREATE: '50000000-0000-0000-0000-000000000002',
  ACTION_RESOURCE_UPDATE: '50000000-0000-0000-0000-000000000003',
  ACTION_RESOURCE_DELETE: '50000000-0000-0000-0000-000000000004',
  ACTION_RESOURCE_EXPORT: '50000000-0000-0000-0000-000000000005',
  ACTION_RESOURCE_IMPORT: '50000000-0000-0000-0000-000000000006',

  // Action (admin)
  ACTION_ACTION_VIEW: '60000000-0000-0000-0000-000000000001',
  ACTION_ACTION_CREATE: '60000000-0000-0000-0000-000000000002',
  ACTION_ACTION_UPDATE: '60000000-0000-0000-0000-000000000003',
  ACTION_ACTION_DELETE: '60000000-0000-0000-0000-000000000004',

  // Subscription
  ACTION_SUBSCRIPTION_VIEW: '70000000-0000-0000-0000-000000000001',
  ACTION_SUBSCRIPTION_MANAGE: '70000000-0000-0000-0000-000000000002',

  // Cross-tenant / super-admin
  ACTION_ORG_VIEW_ALL: '84bd3755-20ba-45fc-8223-85ebd7a8a988',
} as const;
